import { NioxMeasurement } from "../../Types/Common/NioxFeno";
import { OfflineFenoEntry } from "./req-res";

type NioxFenoCustomEvents = {
  "custom:NioxFeno:StartedMeasurement": { startedMeasurement: boolean };
  "custom:NioxFeno:LatestMeasurement": { latestMeasurement: NioxMeasurement | null };
  "custom:NioxFeno:PastMeasurements": { pastMeasurements: (NioxMeasurement | null)[] | null };
  "custom:NioxFeno:RequestMeasurements": { offlineMeasurements: OfflineFenoEntry[] | null };
  "custom:NioxFeno:MeasurementStored": { storedMeasurement: OfflineFenoEntry, success: boolean };
};

export type NioxFenoCustomWindowEventMap = {
  [K in keyof NioxFenoCustomEvents]: CustomEvent<NioxFenoCustomEvents[K]>;
};

const _dispatchCustomEvent = <T extends keyof NioxFenoCustomEvents>(type: T, detail: NioxFenoCustomEvents[T]) => {
  const customEvent = new CustomEvent(type, { detail });
  window.dispatchEvent(customEvent);
};

export const dispatchNioxFenoCustomEvent = {
  startedMeasurement: (startedMeasurement: boolean) => _dispatchCustomEvent("custom:NioxFeno:StartedMeasurement", { startedMeasurement }),
  latestMeasurement: (latestMeasurement: NioxMeasurement | null) => _dispatchCustomEvent("custom:NioxFeno:LatestMeasurement", { latestMeasurement }),
  pastMeasurements: (pastMeasurements: (NioxMeasurement | null)[] | null) => _dispatchCustomEvent("custom:NioxFeno:PastMeasurements", { pastMeasurements }),
  requestOfflineMeasurements: (offlineMeasurements: (OfflineFenoEntry[] | null)) => _dispatchCustomEvent("custom:NioxFeno:RequestMeasurements", { offlineMeasurements }),
  measurementStored: (storedMeasurement: OfflineFenoEntry, success: boolean) => _dispatchCustomEvent("custom:NioxFeno:MeasurementStored", { storedMeasurement, success })
} as const;